import React, { useEffect, useState } from "react";
import "./AnnuaireEtudiantSearchBar.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { FaSearch } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFetchGet, useFetchGetConditional } from "Services/api";
import Localisation from "Components/Localisation/Localisation";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";

const AnnuaireEtudiantSearchBar = (props) => {
  // Stocke l'ensemble des villes, pays et départements des offres
  const [isVisibleLocation, setIsVisibleLocation] = useState(false);
  const [motscles, setMotscles] = useState("");
  const [entreprise, setEntreprise] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [localisation, setLocalisation] = useState("");
  const [composante, setComposante] = useState([]);
  const [domaine, setDomaine] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  const localisationData = useFetchGet(
    "/users/liste_localisation",
    props.auth.token
  );

  const domaineData = useFetchGetConditional(
    "/domains",
    props.auth.token,
    props.secondaryTables.domainsData
  );
  const composanteData = useFetchGetConditional(
    "/education_composantes",
    props.auth.token,
    props.secondaryTables.educationComposanteData
  );

  useEffect(() => {
    domaineData.loaded &&
      composanteData.loaded &&
      props.handleUpdateSecondaryTables({
        domainsData: domaineData.data,
        educationComposanteData: composanteData.data,
      });
  }, [composanteData.loaded, domaineData.loaded]);

  const setRecherche = () => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/users/annuaire`);
    url.searchParams.set("datasVisibleForAllMembers", 1);
    url.searchParams.set("role", "student");

    if (motscles != "") url.searchParams.set("keyword", motscles);
    if (entreprise != "")
      url.searchParams.set("resume.experiences.company", entreprise);
    if (nom != "") url.searchParams.set("surname", nom);
    if (prenom != "") url.searchParams.set("firstname", prenom);
    if (localisation != "") url.searchParams.set("localisation", localisation);

    if (composante) {
      composante.forEach((item) =>
        url.searchParams.append("composante[]", item.id)
      );
    }
    if (domaine) {
      domaine.forEach((item) => url.searchParams.append("domain[]", item.id));
    }

    if (
      motscles === "" &&
      entreprise === "" &&
      nom === "" &&
      prenom === "" &&
      localisation === "" &&
      !composante &&
      !domaine
    ) {
      setIsSearched(false);
    }
    props.setUrlAnnuaire(url);
  };
  return (
    <div className="annuaire_search_bar etudiant_bar">
      <h2 className="annuaire_search_bar__title">Trouvez un étudiant</h2>
      <div className="annuaire_search_bar__container">
        <div className="annuaire_search_bar__container__top">
          <div className="annuaire_search_bar__container__top__boxes">
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label>MOTS CLÉS</label>
              <span className="annuaire_p-input-icon-left">
                <InputText
                  value={motscles}
                  onChange={(e) => setMotscles(e.target.value)}
                  placeholder=" Poste, Entreprise..."
                  className="box__input"
                />
              </span>
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">PRÉNOM</label>
              <InputText
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                placeholder=" Alex, Emma, Julie"
                className="box__input"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">NOM</label>
              <InputText
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder=" Lebon, Dupont"
                className="box__input"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box input_localisation_annuaire">
              <label className="label-annuaire">LOCALISATION</label>
              <InputText
                value={localisation}
                onChange={(e) => {
                  setLocalisation(e.target.value.toLowerCase());
                  if (e.target.value.length > 2) {
                    setIsVisibleLocation(true);
                  } else {
                    setIsVisibleLocation(false);
                  }
                }}
                placeholder=" Pays, ville"
                className="box__input"
              />
              {/* Affichage du menu déroulant groupé des lieux correspondant */}
              {isVisibleLocation && localisationData.loaded && (
                <Localisation
                  location={localisation}
                  listOfData={localisationData.data}
                  btnAction={(element) => {
                    setLocalisation(element.toLowerCase());
                  }}
                  setIsVisibleLocation={setIsVisibleLocation}
                ></Localisation>
              )}
            </div>

            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">ENTREPRISE</label>
              <InputText
                value={entreprise}
                onChange={(e) => setEntreprise(e.target.value)}
                placeholder=" Darty, Lactalis"
                className="box__input"
              />
            </div>
          </div>
          <div
            className="annuaire_search_bar__container__top__inputSearch not_mobile"
            onClick={() => {
              setIsSearched(true);
              setRecherche();
            }}
          >
            <FaSearch />
          </div>
        </div>
        <div className="annuaire_search_bar__container__bottom">
          <ul>
            <li>
              <label className="label-annuaire">Composante</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={composante}
                options={composanteData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setComposante(e.value)}
                optionLabel="label"
                placeholder="Composante"
                maxSelectedLabels={3}
                selectedItemsLabel={`${composante.length} options sélectionnées`}
                className="box__input"
              />
            </li>
            <li>
              <label className="label-annuaire">Formation</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={domaine}
                options={domaineData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setDomaine(e.value)}
                optionLabel="label"
                placeholder="Formation"
                maxSelectedLabels={3}
                selectedItemsLabel={`${domaine.length} options sélectionnées`}
                className="box__input"
              />
            </li>
            {isSearched && (
              <li className="search_bar_refresh search_bar_refresh__annuaireEntreprise">
                <i
                  className="pi pi-refresh"
                  style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  onClick={() => {
                    setIsSearched(false);
                    setDomaine([]);
                    setEntreprise("");
                    setLocalisation("");
                    setMotscles("");
                    setNom("");
                    setPrenom("");
                    setComposante([]);
                    let url = new URL(
                      `${process.env.REACT_APP_BASE_URL_API}/users/annuaire`
                    );
                    url.searchParams.set("datasVisibleForAllMembers", 1);
                    url.searchParams.set("role", "student");
                    props.setUrlAnnuaire(url);
                  }}
                />
              </li>
            )}
          </ul>
        </div>
        <div
          className="annuaire_search_bar__container__top__inputSearch not_desktop"
          onClick={() => {
            setIsSearched(true);
            setRecherche();
          }}
        >
          <FaSearch />
        </div>
      </div>
    </div>
  );
};

AnnuaireEtudiantSearchBar.propTypes = {
  auth: PropTypes.object,
  setUrlAnnuaire: PropTypes.func,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});
const mapDispatchToProps = (dispatch) => ({
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnuaireEtudiantSearchBar);
